import { Badge, type BadgeProps, Tooltip } from "@mantine/core"
import { useTranslation } from "react-i18next"
import type { TCategoryName } from "@/types"

const categoryColors: { [key in TCategoryName]: string } = {
  wellbeing: "lime",
  performance: "blue",
  engagement: "red",
  culture: "green",
  // leadership: "orange",
}

export function ActivityCategory({ value, ...props }: { value: string } & BadgeProps) {
  const { t } = useTranslation()
  return (
    <Tooltip label={t("Category")}>
      <Badge color={categoryColors[value] || "gray"} {...props}>
        {t(value)}
      </Badge>
    </Tooltip>
  )
}
